/**
 * Type-Safe Modal Control Hooks — barrel re-export.
 *
 * The implementation was split across sibling files to keep each module under
 * 300 lines and to separate read-only URL derivation from mutating control
 * logic. Existing imports of `useModalControls`, `useOpenModal`,
 * `useModalUrlState`, `useModalLinks`, `ModalControls`, and
 * `ModalControlOptions` continue to work unchanged from this path.
 *
 * @example
 * ```tsx
 * // Open a deal detail modal
 * const { openModal } = useModalControls('deals-detail');
 * openModal({ dealsId: '123' });
 *
 * // Open with additional parameters
 * const { openModal } = useModalControls('contacts-detail');
 * openModal({ contactsId: '456', tab: 'tasks' });
 *
 * // Close modal and clean URL
 * const { closeModal } = useModalControls('deals-detail');
 * closeModal();
 * ```
 */

"use client";

export type {
  ModalControlOptions,
  ModalControls,
} from "./use-modal-controls.types";

export {
  useModalControls,
  useOpenModal,
} from "./use-modal-controls.mutate";

export {
  useModalUrlState,
  useModalLinks,
} from "./use-modal-controls.read";
